<template>
  <a-form-model ref='form' layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}"  :rules="rules">
    <a-form-model-item label='质疑说明' prop='description' >
      <a-textarea placeholder='请输入质疑该对象的原因' :rows="6" v-model='model.description'></a-textarea>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
  import baseRules from '@/constants/baseRules'
export default {
  name: 'Step5',
  data() {
    return {
      labelCol: {
        xs: { span: 12 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 8 }
      },
      model:{},
      rules: {
        description:[baseRules.required],
      },
    }
  },
  created() {
  },
  methods: {
    view(model){
      this.model = JSON.parse(JSON.stringify(model))
    },
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      let result = false
      this.$refs.form.validate((valid, errorFields) => {
        if (valid) {
          result = true
        }
      })
      return result
    }
  }


}
</script>

<style scoped>

</style>
